const views = {
  "help": require('./views/help.html'),
  "support": require('./views/support.html'),
  "terms": require('./views/terms.html'),
  "terms_mobile": require('./views/terms_mobile.html'),
  "error": require('./views/error.html'),
  "loading": require('./views/loading.html')
}

function CoreConfig($stateProvider, $urlRouterProvider, ConfigEnvironmentProvider) {
  'ngInject';

  const cdnUrl = ConfigEnvironmentProvider.getConfiguration('cdn');
  const greenback = ConfigEnvironmentProvider.getConfiguration('greenback');

  $stateProvider
    .state('help', {
      url: '/help',
      abstract: true,
      views: {
        'main@': {
          template: '<div ui-view/>',
          controller: 'HelpCtrl'
        }
      }
    })
      .state('help.join', {
        url: '/join',
        resolve: {
          questions: function($http) {
            return $http({
              url: `${greenback}api/pages/findOne`,
              params: {
                filter : {"where": {"key": "help_join"}}
              }
            }).then(function(res) {
              return JSON.parse(res.data.body);
            });
          }
        },
        views: {
          'main@': {
            templateUrl: views.help,
            controller: function($scope, questions) {
              $scope.questions = questions;
            }
          }
        }
      })
      .state('help.direct', {
        url: '/direct',
        resolve: {
          questions: function($http) {
            return $http({
              url: `${greenback}api/pages/findOne`,
              params: {
                filter : {"where": {"key": "help_direct"}}
              }
            }).then(function(res) {
              return JSON.parse(res.data.body);
            });
          }
        },
        views: {
          'main@': {
            templateUrl: views.help,
            controller: function($scope, questions) {
              $scope.questions = questions;
            }
          }
        }
      })
      .state('help.loading', {
        url: '/loading',
        templateUrl: views.loading
        //@TODO remove hardcoded paypal verbiage and substitue with stateparams
      })
    .state('faq', {
      url: '/faq',
      resolve: {
        support: function($http) {
          return $http({
            method: 'GET',
            url: cdnUrl + 'gb/faq/support.html'
          }).then(function (response) {
            return response.data;
          });
        }
      },
      views: {
        'main@': {
          templateUrl: views.support,
          controller: function($scope, $sce, support) {
            $scope.support = $sce.trustAsHtml(support);
          }
        }
      }
    })
    .state('terms', {
      url: '/terms',
      abstract: true,
      resolve: {
        terms: function($http) {
          return $http({
            method: 'GET',
            url: cdnUrl + 'gb/terms/terms_and_conditions.html'
          }).then(function (response) {
            return response.data;
          });
        },
        eula: function($http) {
          return $http({
            method: 'GET',
            url: cdnUrl + 'gb/terms/eula.html'
          }).then(function (response) {
            return response.data;
          });
        },
        privacy: function($http) {
          return $http({
            method: 'GET',
            url: cdnUrl + 'gb/terms/privacy.html'
          }).then(function (response) {
            return response.data;
          });
        }
      },
      views: {
        'main@': {
          template: '<div ui-view/>',
          controller: function($scope, $sce, privacy, eula, terms) {
            $scope.privacy = $sce.trustAsHtml(privacy);
            $scope.eula = $sce.trustAsHtml(eula);
            $scope.terms = $sce.trustAsHtml(terms);
          }
        }
      }
    })
    .state('terms.web', {
      url: '/web',
      templateUrl: views.terms
    })
    .state('terms.mobile', {
      url: '/mobile',
      templateUrl: views.terms_mobile
    })
    .state('error', {
      url: '/error',
      abstract: true,
      views: {
        'main@': {
          template: '<div ui-view/>',
          controller: function($scope) {
            $scope.error = {
              description: "",
              options: "Where would you like to go from here?"
            }
          }
        }
      }
    })
    .state('error.500', {
      url: '/500/:errMsg',
      templateUrl: views.error,
      controller: function($scope, $stateParams) {
        if($stateParams.errMsg) {
          $scope.error.description = $stateParams.errMsg;
        }
        else {
          $scope.error.description = "Please try again. If the error persists, select Report Error and let us help you resolve the issue!";
        }
      }
    })
    .state('error.404', {
      url: '/404',
      templateUrl: views.error,
      controller: function($scope) {
        $scope.error.description = "The page you're looking for may have moved or we may be making improvements.";
      }
    })
    .state('error.stripe', {
      url: '/stripe',
      templateUrl: views.error,
      controller: function($scope) {
        $scope.error.description = 'Uh-oh! There appears to be a problem with Stripe.';
        $scope.error.options = 'Stripe\'s payment processing servers seem to be experiencing high traffic, and were unable to complete your payment at this time. Once your payment processing has been completed you will receive an emailed receipt, and the ability to access the greenback mobile app.';
      }
    })
    .state('error.payment', {
      url: '/payment',
      templateUrl: views.error,
      controller: function($scope) {
        $scope.error.description = "We can't seem to connect to PayPal at this time, but we're working on it.";
        $scope.error.options = "We suggest you try again later or report this error.";
      }
    })
    .state('error.paypal', {
      url: '/paypal',
      templateUrl: views.error,
      controller: function($scope) {
        $scope.error.description = 'Paypal is experiencing server issues.';
        $scope.error.options = 'Please login later to complete your transaction';
      }
    })
    .state('error.ipn', {
      url: '/ipn',
      templateUrl: views.error,
      controller: function($scope) {
        $scope.error.description = 'PayPal is taking longer than expected.';
        $scope.error.options = 'PayPal is taking longer than usual to process your transaction. Please check your email for PayPal to confirm your payment acceptance. Once your PayPal confirms your transaction you will be able to access the greenback mobile app.';
      }
    })
    .state('error.echeck', {
      url: '/echeck',
      templateUrl: views.error,
      controller: function($scope) {
        $scope.error.description = "Important notice regarding your chosen payment method.";
        $scope.error.options = "You chose to pay using PayPal eCheck. It usually takes up to up to 6 business days for an eCheck to clear and the money to appear in the recipient's PayPal account. Once the eCheck is cleared your membership will be activated. We will send you an email once your membership has been activated.";
      }
    })
    ;
}

export default CoreConfig;



// WEBPACK FOOTER //
// ./js/containers/core/core.config.js